import { useMutation, useQueryClient } from '@tanstack/react-query';

import { session } from '@/shared/session/session';

import { authApi } from '../api/auth-api';

/** Finishes a challenged sign-in; the step renders its own errors. */
export function useVerifyTwoFactor() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: authApi.verifyTwoFactor,
    meta: { silentError: true },
    onSuccess: () => session.refreshSession(queryClient),
  });
}
